export enum QueryKeys {
  BRANDS = 'brands',
  USERS = 'users',
  ROLES = 'roles',
  PERMISSIONS = 'permissions',
  ADDONS = 'addons',
  EXTENSIONS = 'extensions',
  USER_VENUE_ACCESS = 'userVenueAccess',
  BRAND_VENUES = 'brandVenues',
}
